import { initMercadoPago } from "@mercadopago/sdk-react";

initMercadoPago(process.env.REACT_APP_MP_PUBLIC_KEY);
